export const SET_ADDITIONAL_USER_INFO = 'user/SET_ADDITIONAL_USER_INFO';
export const SET_ROLE = 'user/SET_ROLE';
